var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star"},_vm._l((_vm.starList),function(item,index){return _c('span',{key:index,staticClass:"star-item",class:item,on:{"click":function($event){return _vm.starClick(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }